import { fetchWrapper, objectToQueryParams } from '../utils';

export class plan {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/plans';

  static async get(filters) {
    return await fetchWrapper.post(this.baseUrl, filters);
  }

  static async create(form) {
    const url = `${this.baseUrl}/create`;
    return await fetchWrapper.post(url, form);
  }

  static async update(form) {
    const url = `${this.baseUrl}/update`;
    return await fetchWrapper.post(url, form);
  }

  static async destroy(form) {
    const url = `${this.baseUrl}/destroy`;
    return await fetchWrapper.post(url, form);
  }
}